module.exports = __webpack_public_path__ + "media/images/welcome5-cfcaf5a356d8b09752197e41713d43a7.jpg";